<template>
  <table class="table table-hover" v-cloak>
    <div v-for="(permission, index) in permissions" :key="index">
      <thead>
        <tr>
          <th scope="col" style="width:50%">{{permission.key}}</th>
          <th scope="col">
            {{permission.key === 'User Setting' ? 'No Access' : 'No Access'}}</th>
          <th scope="col">
            {{permission.key === 'User Setting' ? 'Read Only' : 'Read Only'}}</th>
          <th scope="col" >
            {{permission.key === 'User Setting' ? 'Manage' : 'Manage' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(test, index) in permission.value" :key="index">
          <td>{{ test.name }}</td>
          <td><b-form-radio v-model="test.value"
          value='no access' :disabled="permissionDisable(test.name, 'no access')">
          </b-form-radio></td>
          <td><b-form-radio v-model="test.value"
          value='read only' :disabled="permissionDisable(test.name, 'read only')">
          </b-form-radio></td>
          <td><b-form-radio v-model="test.value"
          value='manage' :disabled="permissionDisable(test.name, 'manage')">
          </b-form-radio></td>
        </tr>
      </tbody>
    </div>
  </table>
</template>

<script>
export default {
  name: 'PermissionAdmin',
  props: ['permissions'],
  data() {
    return {
      disabledPermission: {
        'Admin Account': {
          'no access': true,
          'read only': true,
          manage: true,
        },
        'User Profile': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Set Rates': {
          'no access': true,
          'read only': true,
          manage: true,
        },
        'Booking Details': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Booking Charges': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Payment Activity': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Shipment Record-Pickup': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Shipment Record-Warehouse': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Shipment Record-ToLoad': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Shipment Record-Delivering': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Delivered': {
          'no access': true,
          'read only': false,
          manage: true,
        },
        'Shipment Record-Unpaid': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Shipment Record-Flagged': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Manifest Details': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Analytics-Dashboard': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Analytics-Mangement': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Customer BOL': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Dock Receipt': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Master Bol-Manifest': {
          'no access': false,
          'read only': true,
          manage: true,
        },
        'Airway Bol': {
          'no access': true,
          'read only': true,
          manage: true,
        },
      },
    };
  },
  methods: {
    permissionDisable(name, toggle) {
      return this.disabledPermission[name][toggle];
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();
  },
};
</script>

<style scoped>

</style>
